import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';

import ProgressiveImage from '../../components/Image/ProgressiveImage';
import Swiper from '../../components/Swiper/Swiper';

const swiperSettings = {
  slidesToScroll: 1,
  dots: true,
  infinite: false,
  autoplay: false,
  accessibility: false,
  arrows: false,
  slidesToShow: 1,
  responsive: [
    {
      // tablet
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      // mobile portrait
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

// Every slide spans the full viewport width up to the md breakpoint, which is the
// only range this component renders in. Declaring it explicitly (instead of relying
// on the 100vw default) is what lets the hero's preload carry a matching
// `imagesizes`, so preload and <img> resolve to the same srcset candidate.
const SLIDE_SIZES = '100vw';

const ListingImage = ({ image, title, handleViewPhotosClick, loadingStyle, isFirst }) => {
  return (
    <Box
      onClick={(e) => handleViewPhotosClick('image', e)}
      sx={{
        height: '45vh',
        ...(image.style ? image.style : {}),
      }}
    >
      <ProgressiveImage
        addHelmet={isFirst}
        alt={title}
        blurSrc={image.blurSrc}
        loadLazy={!isFirst}
        loadingStyle={loadingStyle}
        sizes={SLIDE_SIZES}
        src={image.src}
        srcset={image.srcset}
      />
    </Box>
  );
};

const NoImagesPlaceholder = () => (
  <Grid alignItems="center" container justifyContent="center" size={12}>
    <Box
      alignItems="center"
      bgcolor="white"
      border="1px solid #FAFAFA"
      borderRadius={2}
      display="flex"
      flexDirection="column"
      height="30vh"
      justifyContent="center"
      width={1}
    >
      <HelpOutlineOutlinedIcon sx={{ fontSize: 128, color: '#FAFAFA' }} />
      <Typography variant="h5">This Listing has no images!</Typography>
    </Box>
  </Grid>
);

const SwiperMobile = ({
  isMobile,
  hasImages,
  images,
  title,
  viewPhotosButton,
  viewSurroundPhotosButton,
  onImageClick = () => {},
}) => {
  if (!isMobile) return null;

  const renderSwiper = () => (
    <Box
      bgcolor="#FAFAFA"
      sx={{
        width: '100%',
        paddingTop: '300px',
        position: 'relative',
      }}
    >
      {/* Swiper component, effectively positioned above the "Skeleton" */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
        {/*
          No `lazyLoad` prop here on purpose: react-slick's own lazy loading replaces
          every slide's children with an empty <div> until it decides (in
          componentDidMount, i.e. client-side only) which slides to mount. That means
          the first slide's <img> never exists in the SSR HTML, which defeats the
          eager/preload priority set on it below. ListingImage/ProgressiveImage already
          do their own per-image `loading` lazy-loading, so slick's lazyLoad is redundant.
        */}
        <Swiper {...swiperSettings}>
          {images.slice(0, 6).map((image, index) => (
            <ListingImage
              handleViewPhotosClick={onImageClick}
              image={image}
              isFirst={index === 0}
              key={index}
              loadingStyle={index === 0 ? 'eager' : 'lazy'}
              title={title}
            />
          ))}
        </Swiper>
      </Box>
      {viewPhotosButton}
      {viewSurroundPhotosButton}
    </Box>
  );

  return hasImages ? renderSwiper() : <NoImagesPlaceholder />;
};

export default SwiperMobile;
